import { AUTHENTICATE_SUCCESS, AUTHENTICATE_FAIL } from '../actions/types';

const INITIAL_STATE = {
	active: false,
	signedIn: false,
	displayName: '',
	email: '',
	emailVerified: false,
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case AUTHENTICATE_SUCCESS:
			return {
				...state,
				signedIn: true,
				displayName: action.payload.displayName,
				email: action.payload.email,
				emailVerified: action.payload.emailVerified,
				active: action.payload.active,
			};
		case AUTHENTICATE_FAIL:
			return {
				...state,
				active: false,
				signedIn: false,
				displayName: '',
				email: '',
				emailVerified: false,
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js